"use client";
import { useTheme } from "next-themes";
import { Toaster as Sonner } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const isValidSonnerTheme = (
  theme: string | undefined
): theme is ToasterProps["theme"] =>
  theme === "light" || theme === "dark" || theme === "system";

export const Toaster = ({ ...props }: ToasterProps) => {
  const { theme } = useTheme();
  const validTheme = isValidSonnerTheme(theme) ? theme : "system";

  return (
    <Sonner
      theme={validTheme}
      position="bottom-right"
      gap={14}
      offset={24}
      closeButton
      duration={6000}
      className="toaster group"
      {...props}
    />
  );
};
